import React from "react";
import { Block } from "@/components/form/Block";
import { FormLabel } from "@/components/form/FormLabel";
import { Box, Link, Typography } from "@mui/material";

interface RegistrationSuccessfullProps {
  email: string;
}

export const RegistrationSuccessful: React.FC<RegistrationSuccessfullProps> = ({
  email,
}) => {
  return (
    <Block>
      <FormLabel>
        <Typography mb={3} fontSize={"2rem"}>
          Výborně!
        </Typography>
        <Box>
          Registrace na seminář proběhla úspěšně. Na email {email} obdržíte
          potvrzení o registraci. Pokud jste email nedostali, zkontrolujte
          adresář spam. Pro návrat na web klikněte{" "}
          <Link href={"http://www.vys-edu.cz/ap"}>zde</Link>.
        </Box>
        <Box>Chcete zaregistrovat dalšího účastníka? Obnovte stránku.</Box>
      </FormLabel>
    </Block>
  );
};
